export default "__VITE_ASSET__DDrS5RB8__"